<!--
재고입고(등록) 에서 사용되는 상품(1개) 컴포넌트

-->
<template>
    <li class="prod-component">
        <!-- 인덱스 히든 변수 -->
        <input
                type="hidden"
                name="idxs[]"
                :value="index"

        />

        <div uk-grid >
            <!-- 보관정보 -->
            <app-stock-reg-fieldset class="uk-width-1-4@l store" title="(중요) 보관정보" important>
                <div>

                    <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="storage"
                            :name="makeInputName('storage')"
                            v-model="columns.storage"
                            label="보관장소"

                            placeholder="보관장소 입력하세요!"
                    > </app-input-ex>

                    <app-input-ex
                            class="input"
                            type="text"
                            input-size="small"

                            ref="amount"
                            :name="makeInputName('amount')"
                            v-model="columns.amount"
                            label="수량"

                            :validate-rules="{required: true, numeric: true}"
                            required
                            required-layout="label-left"

                            placeholder="수량체크 하세요!"
                    > </app-input-ex>
                </div>
            </app-stock-reg-fieldset>

            <!-- 상품정보 -->
            <app-stock-reg-fieldset class="uk-width-1-2@l prod" title="상품">
                <div uk-grid class="uk-grid-small">
                    <app-input-ex
                        class="input uk-width-1-1"
                        type="text"
                        input-size="small"

                        ref="name"
                        :name="makeInputName('name')"
                        v-model="columns.name"
                        label="상품명"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        placeholder="현지 상품명"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-1"
                        type="text"
                        input-size="small"

                        ref="name_eng"
                        :name="makeInputName('name_eng')"
                        v-model="columns.name_eng"
                        label="상품명(영어)"

                        placeholder="통관시 사용되는 영문 상품명"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="brand"
                        :name="makeInputName('brand')"
                        v-model="columns.brand"
                        label="브랜드"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="prod_code"
                        :name="makeInputName('prod_code')"
                        v-model="columns.prod_code"
                        label="상품코드"

                        placeholder="회원사 자체 관리코드"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="color"
                        :name="makeInputName('color')"
                        v-model="columns.color"
                        label="색상"
                    > </app-input-ex>



                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="size"
                        :name="makeInputName('size')"
                        v-model="columns.size"
                        label="사이즈"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="unit_price"
                        :name="makeInputName('unit_price')"
                        v-model="columns.unit_price"
                        label="단가"

                        :placeholder="'1개 상품가격('+regionCurrency+'), 숫자로만 입력'"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="vender_mall"
                        :name="makeInputName('vender_mall')"
                        v-model="columns.vender_mall"
                        label="쇼핑몰"

                        placeholder="예시 : www.amazon.co.jp"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="vender_code"
                        :name="makeInputName('vender_code')"
                        v-model="columns.vender_code"
                        label="해외상품코드"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-1"
                        type="text"
                        input-size="small"

                        ref="vender_url"
                        :name="makeInputName('vender_url')"
                        v-model="columns.vender_url"
                        label="상세URL"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-1"
                        type="text"
                        input-size="small"

                        ref="img_url"
                        :name="makeInputName('img_url')"
                        v-model="columns.img_url"
                        label="이미지URL"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-1"
                        type="select"
                        input-size="small"

                        ref="hscode"
                        :name="makeInputName('hscode')"
                        v-model="columns.hscode"
                        label="HS코드"

                        :options="hscodeOptions"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-2@m"
                        type="text"
                        input-size="small"

                        ref="type_name"
                        :name="makeInputName('type_name')"
                        v-model="columns.type_name"
                        label="품목명"

                        placeholder="e.g. CLOTHES"
                        desc-msg="영문으로 작성하세요"
                    > </app-input-ex>

                    <app-input-ex
                        class="input uk-width-1-1"
                        type="textarea"
                        input-size="small"

                        ref="memo"
                        :name="makeInputName('memo')"
                        v-model="columns.memo"
                        label="관리메모"

                        :textarea-rows="3"
                    > </app-input-ex>
                </div>
            </app-stock-reg-fieldset>

            <!-- 해외오더정보 -->
            <app-stock-reg-fieldset class="uk-width-1-4@l vendor" title="해외오더">
                <div>
                    <app-input-ex
                        class="input"
                        type="text"
                        input-size="small"

                        ref="buy_order_code"
                        :name="makeInputName('buy_order_code')"
                        v-model="columns.buy_order_code"
                        label="해외주문번호"
                    > </app-input-ex>

                    <app-input-ex
                        class="input"
                        type="radio"
                        input-size="small"

                        ref="p_shipping_center"
                        :name="makeInputName('shipping_center')"
                        v-model="columns.shipping_center"
                        label="배송지"

                        :options="shippingCenterOptions"
                    > </app-input-ex>

                    <app-input-ex
                        class="input"
                        type="text"
                        input-size="small"

                        ref="tracking_no"
                        :name="makeInputName('tracking_no')"
                        v-model="columns.tracking_no"
                        label="트래킹번호"
                    > </app-input-ex>

                    <app-input-ex
                        class="input"
                        type="text"
                        input-size="small"

                        ref="buy_unit_price"
                        :name="makeInputName('buy_unit_price')"
                        v-model="columns.buy_unit_price"
                        label="구입단가"

                        :placeholder="'1개 상품가격('+regionCurrency+') *통관시 전송되는 금액'"
                    > </app-input-ex>
                </div>
            </app-stock-reg-fieldset>

        </div>
        


        <div class="uk-text-center">
            <!-- 복사버튼 -->
            <button
                    type="button"
                    class="uk-button uk-button-primary uk-button-small"
                    v-on:click="duplicate"
            >
                <span uk-icon="icon: copy"></span>
                {{ duplicateButtonText }}
            </button>

            <!-- 삭제버튼 -->
            <button
                    type="button"
                    class="uk-button uk-button-danger uk-button-small"
                    v-on:click="remove"
                    :disabled="removeButtonDisable"
            >
                <span uk-icon="icon: minus-circle"></span>
                {{ removeButtonText }}
            </button>
        </div>
        
    </li>
</template>

<script>
    export default {
        props: {
            columns: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            duplicateButtonText: {
                type: String
            },
            removeButtonText: {
                type: String
            },
            removeButtonDisable: Boolean, // 삭제버튼 활성화여부

            /**
             * HS코드표 옵션 배열
             */
            hscodeOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 배송지 옵션 배열
             */
            shippingCenterOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 지역기본 화폐단위
             */
            regionCurrency: {
                type: String,
            },
        },
        data: function () {
            return {
                
            };
        },
        computed: {
        },
        watch: {
        },
        methods: {
            /**
             * 복제이벤트 발생
             */
            duplicate: function () {
                this.$emit('duplicate', this.index);
            },
            /**
             * 제거 이벤트 발생
             */
            remove: function () {
                this.$emit('remove', this.index)
            },
            changeInput: _.debounce(function (event) {
                // 검증구문 들어가면 됨
                //console.log(event.target.value);
            }, 500),
            /**
             * index 번호로 input 의 name을 작성
             */
            makeInputName: function (column_name) {
                return column_name + '_' + this.index;
            }
        }
    }
</script>

<!-- 하위컴포넌트의 요소에 영향을 주기위해서 scope 설정하지않음. -->
<style lang="scss">
    .prod-component{
        fieldset.uk-fieldset {
            // 인풋요소 여백
            .input {
                margin-top: 0px;
                margin-bottom: 5px;
            }

            // 소제목
            .uk-legend{
                font-size: 1.125rem; 
            }

            @media (min-width: 960px) {
                .uk-form-label {
                    text-align: right;
                }
            }

            // 상품정보
            &.prod {
                // input 라벨 가로길이 조정
                @media (min-width: 960px) {
                    .uk-form-label {
                        width: 90px;
                    }

                    .uk-form-controls {
                        margin-left: 105px;
                    }
                }
            }

            // 보관정보
            &.store {
                // input 라벨 가로길이 조정
                @media (min-width: 960px) {
                    .uk-form-label {
                        width: 90px;
                    }

                    .uk-form-controls {
                        margin-left: 105px;
                    }
                }
            }

            // 해외오더
            &.vendor {
                // input 라벨 가로길이 조정
                @media (min-width: 960px) {
                    .uk-form-label {
                        width: 90px;
                    }

                    .uk-form-controls {
                        margin-left: 105px;
                    }
                }
            }

        }
    }
</style>